<template>
  <div>
    <div class="dashboard-items-header">
      <span
        class="dashboard-items-header__title"
      >
        {{ title }}
      </span>
      <period-dropdown-filter
          v-model="periodDays"
          @onClickPeriodFilter="onClickPeriodFilterHandler"
        />
    </div>
    <div class="dashboard-items-header__line-bottom"></div>
  </div>
</template>

<script>
import PeriodDropdownFilter from '@/components/PeriodDropdownFilter';
import periods from '@/domain/enums/periods-dropdown-filter';

export default {
  name: 'DashboardItemsHeader',
  components: { PeriodDropdownFilter },
  props: {
    title: {
      type: String,
      require: true,
    },
    periodDays: {
      type: Number,
      default: () => periods.SEVEN,
    },
  },
  methods: {
    onClickPeriodFilterHandler(value) {
      this.$emit('onClickPeriodFilter', value);
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.dashboard-items-header
  display: flex
  justify-content: space-between
  &__title
    font-size: 1.08rem
    font-weight: bold
    color: var(--font-color-primary)
    text-transform: uppercase
  &__line-bottom
    border-bottom: .2rem solid var(--font-color-primary)
</style>
